// European countries with major cities and coordinates [lat, lng]
export const EUROPE = {
  Nederland: {
    code: "NL",
    cities: {
      Amsterdam: [52.3676, 4.9041], Rotterdam: [51.9244, 4.4777], "Den Haag": [52.0705, 4.3007],
      Utrecht: [52.0907, 5.1214], Eindhoven: [51.4416, 5.4697], Groningen: [53.2194, 6.5665],
      Tilburg: [51.5555, 5.0913], Breda: [51.5719, 4.7683], Nijmegen: [51.8126, 5.8372], Maastricht: [50.8514, 5.6910],
    },
  },
  België: {
    code: "BE",
    cities: {
      Brussel: [50.8503, 4.3517], Antwerpen: [51.2194, 4.4025], Gent: [51.0543, 3.7174],
      Charleroi: [50.4108, 4.4446], Luik: [50.6326, 5.5797], Brugge: [51.2093, 3.2247],
    },
  },
  Duitsland: {
    code: "DE",
    cities: {
      Berlin: [52.52, 13.405], München: [48.1351, 11.582], Hamburg: [53.5511, 9.9937],
      Köln: [50.9375, 6.9603], Frankfurt: [50.1109, 8.6821], Stuttgart: [48.7758, 9.1829],
      Düsseldorf: [51.2277, 6.7735], Dortmund: [51.5136, 7.4653],
    },
  },
  Frankrijk: {
    code: "FR",
    cities: {
      Paris: [48.8566, 2.3522], Marseille: [43.2965, 5.3698], Lyon: [45.764, 4.8357],
      Toulouse: [43.6047, 1.4442], Nice: [43.7102, 7.262], Lille: [50.6292, 3.0573], Bordeaux: [44.8378, -0.5792],
    },
  },
  "Verenigd Koninkrijk": {
    code: "GB",
    cities: {
      London: [51.5074, -0.1278], Manchester: [53.4808, -2.2426], Birmingham: [52.4862, -1.8904],
      Glasgow: [55.8642, -4.2518], Liverpool: [53.4084, -2.9916], Leeds: [53.8008, -1.5491],
    },
  },
  Spanje: {
    code: "ES",
    cities: {
      Madrid: [40.4168, -3.7038], Barcelona: [41.3851, 2.1734], Valencia: [39.4699, -0.3763],
      Sevilla: [37.3891, -5.9845], Málaga: [36.7213, -4.4214], Bilbao: [43.263, -2.935],
    },
  },
  Italië: {
    code: "IT",
    cities: {
      Roma: [41.9028, 12.4964], Milano: [45.4642, 9.19], Napoli: [40.8518, 14.2681],
      Torino: [45.0703, 7.6869], Firenze: [43.7696, 11.2558], Venezia: [45.4408, 12.3155],
    },
  },
  Portugal: {
    code: "PT",
    cities: { Lisboa: [38.7223, -9.1393], Porto: [41.1579, -8.6291], Braga: [41.5454, -8.4265], Faro: [37.0194, -7.9304] },
  },
  Oostenrijk: {
    code: "AT",
    cities: { Wien: [48.2082, 16.3738], Graz: [47.0707, 15.4395], Salzburg: [47.8095, 13.055], Innsbruck: [47.2692, 11.4041] },
  },
  Zwitserland: {
    code: "CH",
    cities: { Zürich: [47.3769, 8.5417], Genève: [46.2044, 6.1432], Bern: [46.948, 7.4474], Basel: [47.5596, 7.5886] },
  },
  Polen: {
    code: "PL",
    cities: { Warszawa: [52.2297, 21.0122], Kraków: [50.0647, 19.945], Wrocław: [51.1079, 17.0385], Gdańsk: [54.352, 18.6466] },
  },
  Zweden: {
    code: "SE",
    cities: { Stockholm: [59.3293, 18.0686], Göteborg: [57.7089, 11.9746], Malmö: [55.605, 13.0038] },
  },
  Denemarken: {
    code: "DK",
    cities: { København: [55.6761, 12.5683], Aarhus: [56.1629, 10.2039], Odense: [55.4038, 10.4024] },
  },
  Noorwegen: {
    code: "NO",
    cities: { Oslo: [59.9139, 10.7522], Bergen: [60.3913, 5.3221], Trondheim: [63.4305, 10.3951] },
  },
  Ierland: {
    code: "IE",
    cities: { Dublin: [53.3498, -6.2603], Cork: [51.8985, -8.4756], Galway: [53.2707, -9.0568] },
  },
};

export const COUNTRY_NAMES = Object.keys(EUROPE);

export function citiesOf(country) {
  return EUROPE[country] ? Object.keys(EUROPE[country].cities) : [];
}

export function coordsOf(country, city) {
  return EUROPE[country]?.cities[city] || null;
}

// Haversine distance in km
export function distanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
